import { Box, HStack, VStack, Icon, Tooltip, TooltipContent, Button, TooltipText, View, Pressable } from "components/ui";
import React, { ComponentProps } from "react";
import { Typography } from "./Typography";
import { HelpCircle } from "lucide-react-native";
import { Switch } from "react-native-switch";
import HelpTooltip from "components/general/HelpTooltip";

type Props = {
	text: string;
	defaultValue?: boolean;
	isLastItem?: boolean;
	onChange?: (value: boolean) => void;
};

const SwitchBasic = ({ text, defaultValue = false, isLastItem, onChange, ...props }: ComponentProps<typeof Box> & Props) => {
	const [isEnabled, setIsEnabled] = React.useState(defaultValue);
	const toggleSwitch = () => {
		const newState = !isEnabled;
		setIsEnabled(newState);
		if (onChange) {
			onChange(newState);
		}
	};
	return (
		<Box borderBottomWidth={(props.borderBottomWidth ?? isLastItem) ? 0 : 1} borderColor="$neutral100" paddingVertical={14} {...props}>
			<HStack space="md" alignItems="center">
				<Pressable>
					<Switch
						barHeight={20}
						circleSize={20}
						value={isEnabled}
						onValueChange={toggleSwitch}
						backgroundActive={"#2B6FBB"}
						backgroundInactive={"#E3F1FA"}
						circleActiveColor={"white"}
						circleBorderWidth={12}
						changeValueImmediately={true} // if rendering inside circle, change state immediately or wait for animation to complete
						innerCircleStyle={{
							alignItems: "center",
							justifyContent: "center",
							borderColor: "#2B6FBB",
							borderWidth: isEnabled ? 2 : 1,
						}}
						outerCircleStyle={{}} // style for outer animated circle
						renderActiveText={false}
						renderInActiveText={false}
						switchWidthMultiplier={2} // multiplied by the `circleSize` prop to calculate total width of the Switch
					/>
				</Pressable>
				<Typography>{text}</Typography>
			</HStack>
		</Box>
	);
};

export default SwitchBasic;
